import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {autobind} from 'core-decorators';
import classNames from 'classnames';
import {Toggle} from 'components/forms';
import styles from './styles.css';

@autobind
export default class RadioGroup extends Component {
    static propTypes = {
        value: PropTypes.any.isRequired,
        options: PropTypes.arrayOf(PropTypes.shape({
            value: PropTypes.any.isRequired,
            label: PropTypes.string.isRequired,
        })).isRequired,
        disabled: PropTypes.bool,
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func,
    };

    handleChange(option) {
        return () => this.props.onChange(option.value);
    }

    render() {
        return (
            <div className={classNames(styles.root, {[styles.disabled]: this.props.disabled})}>
                {this.props.options.map(option => (
                    <Toggle
                        key={option.value}
                        type='radio'
                        value={option.value === this.props.value}
                        label={option.label}
                        disabled={this.props.disabled}
                        onChange={this.handleChange(option)}
                        onBlur={this.props.onBlur}
                    />
                ))}
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./components/forms/radio-group/index.js